"use client";
import { ReactNode } from "react";

import { Control, FieldValues, Path } from "react-hook-form";

import {
  FormField,
  FormItem,
  FormLabel,
  CountryDropdown,
  cn,
  labelClassName,
  formInputClassName,
} from "../../../index";
import { getCountryAlpha2, getCountryName } from "@ac-expo/utils";

type FormCountryProps<TForm extends FieldValues> = {
  control: Control<TForm>;
  name: Path<TForm>;
  label?: ReactNode;
  className?: string;
  asName?: boolean;
  disabled?: boolean;
};

export function FormCountry<TForm extends FieldValues>({
  control,
  name,
  label,
  className,
  asName = false,
  disabled,
}: FormCountryProps<TForm>) {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field, fieldState: { error } }) => {
        const countryAlpha2 = getCountryAlpha2(field.value);

        return (
          <FormItem className={cn(formInputClassName, className)}>
            {label ? (
              <FormLabel className={labelClassName}>{label}</FormLabel>
            ) : null}

            <CountryDropdown
              placeholder="Sélectionner un pays"
              defaultValue={countryAlpha2}
              onChange={(country) => {
                field.onChange(
                  asName ? getCountryName(country.alpha2) : country.alpha2
                );
              }}
              isError={!!error}
              disabled={disabled}
            />
          </FormItem>
        );
      }}
    />
  );
}
